import { Expression, SqlOptions } from '../../types';

export default function statusFormatter(
  sqlOptions: SqlOptions,
  expression: Expression,
): Expression | null {
  const { field, value, operator } = expression;
  if (!field.toLowerCase().endsWith('status')) {
    return null;
  }

  return { field: '_status', operator: operator || 'text_equal', value };
}
